/* unplugin-vue-components disabled */import { render } from "./ExpensesRecord.vue?vue&type=template&id=20abfdc4&scoped=true"
import script from "./ExpensesRecord.vue?vue&type=script&lang=js"
export * from "./ExpensesRecord.vue?vue&type=script&lang=js"

import "./ExpensesRecord.vue?vue&type=style&index=0&id=20abfdc4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20abfdc4"]])

export default __exports__